var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96999 16.5L10.5522 14.8139V10.3953L16.1695 4.69842C16.3812 4.48496 16.5 4.192 16.5 3.8852V2.63816C16.5 2.00902 16.0063 1.5 15.3971 1.5H2.60287C1.9937 1.5 1.5 2.00902 1.5 2.63816V3.91372C1.5 4.20323 1.60627 4.48151 1.79789 4.69237L6.96999 10.3953V16.5Z",
    stroke: "#145DA0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.1308f0d33b0d1aa6bcf40fc985200667.svg";
export { ForwardRef as ReactComponent };